// \b anchors prevent false-positives on hostnames like notcdn.pendo.io
const PENDO_CDN = /\bcdn(?:\.eu)?\.pendo\.io\b/;

export function isPendoError(event, hint = {}) {
  const exc = hint?.originalException;
  const stack = (typeof exc === 'string' ? exc : exc?.stack) ?? '';
  if (PENDO_CDN.test(stack)) {
    return true;
  }

  return (event?.exception?.values ?? []).some((v) =>
    (v?.stacktrace?.frames ?? []).some((f) =>
      PENDO_CDN.test(f?.filename ?? ''),
    ),
  );
}
